/* tslint:disable */
import {Injectable} from '@angular/core';
import {HttpService} from "../../http.service";
import {environment} from "../../../environments/environment";
import {NeuronsService} from "./neurons.service";
import {NgxSpinnerService} from "ngx-spinner";
import {TabService} from "../../tab.service";
import {LayoutService} from "../layout/layout.service";
import {EllipsoidROI} from "../ROIs/ShapeROIsModel";
import {AlertService} from "../../alert.service";
import {BehaviorSubject} from "rxjs";
import {AtlasSharedService} from "../atlas-shared.service";
import { getBoundingBox } from '../helpers/bouding_box-helper';
import { WebGLService } from '../views/three-dview/web-gl.service';
import {StatusMessageService} from "../status-message.service";

@Injectable({
    providedIn: 'root'
})
export class NeuronsSearchService {
    public neuronsLoadingParameters = {
        progress: 0,
        totalNeuronsToDraw: 0,
        threshold: 100
    }

    private urlGetNeuronsData = environment.apiURL + 'get_neurons_data';
    private urlSearchForNeuronsIDsByPublication = environment.apiURL + 'search_for_neurons_ID_by_publication';
    private urlSearchForNeuronsIDsByLines = environment.apiURL + 'search_for_neurons_IDs_by_lines';
    private urlSearchForNeuronsIDsByCellType = environment.apiURL + 'search_for_neurons_IDs_by_cell_type';
    private urlSearchForNeuronsIDsInRegion = environment.apiURL + 'search_for_neurons_IDs_by_region';
    private urlSearchForNeuronsIDsInROI = environment.apiURL + 'search_for_neurons_IDs_in_roi';
    private urlSearchInMask = environment.apiURL + 'search_for_neurons_by_user_mask';
    private urlSearchForNeuronsIDByShareViewLink = environment.apiURL + 'search_for_neurons_IDs_by_share_view_link';
    private urlLoadAllNeurons = environment.apiURL + 'load_all_neurons';

    constructor(private httpService: HttpService,
                private neuronsService: NeuronsService,
                private spinner: NgxSpinnerService,
                private atlasSharedService: AtlasSharedService,
                private tabService: TabService,
                private layoutService: LayoutService,
                private alertService: AlertService,
                private webGLService: WebGLService
            ,
                private statusMessageService: StatusMessageService) {
    }

    async searchForNeuronsInRegion(regionId: number, searchOption: number, minimumNeuronLengthInRegion: number) {
        await this.statusMessageService.updateStatus("Start searching for neurons in Regions", true);
        this.httpService.postRequest(this.urlSearchForNeuronsIDsInRegion, {
            regionId: regionId,
            searchOption: searchOption,
            minimumNeuronLengthInRegion: minimumNeuronLengthInRegion
        }).subscribe(response => {
                this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
            },
            error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                this.spinner.hide();
            });
    }

    async searchForNeuronsInROI(roi: EllipsoidROI, searchOption: number, minimumNeuronLengthInRegion: number) {
        await this.statusMessageService.updateStatus("Start searching for neurons in ROI", true);
        this.httpService.postRequest(this.urlSearchForNeuronsIDsInROI, {
            roiBackendData: roi.backendData,
            roiName: roi.name,
            searchOption: searchOption,
            minimumNeuronLengthInRegion: minimumNeuronLengthInRegion
        }).subscribe(response => {
                this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
            },
            async error => {
                await this.statusMessageService.updateStatus("Something went wrong", true,true,1000);
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
            });
    }

    searchForNeuronsInMask(maskID, SearchOption) {
        this.spinner.show();

        this.httpService.postRequest(this.urlSearchInMask, {
            maskID: maskID,
            searchOption: SearchOption
        }).subscribe(retrievedNeuronsGroupData => {
            this.neuronsService.receiveNeuronsFromBackend(retrievedNeuronsGroupData, false, true);
            this.spinner.hide();

        },
            error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                this.spinner.hide();

            });
    }

    searchForNeuronsByPublication(selectedPublicationID) {
        this.spinner.show();
        this.httpService.postRequest(this.urlSearchForNeuronsIDsByPublication, {
            publicationID: selectedPublicationID
        }).subscribe(response => {
                this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
                this.spinner.hide();
            },
            error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                this.spinner.hide();
            });
    }


    searchForNeuronsByMarkers(selectedMarkerID) {
        this.spinner.show();

        this.httpService.postRequest(this.urlSearchForNeuronsIDsByLines, {
            selectedLineID: selectedMarkerID
        }).subscribe(response => {
                this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
                this.spinner.hide();
            },
            error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                this.spinner.hide();
            });
    }


    searchForNeuronsByCellType(selectedCellTypeID) {
        this.spinner.show();

        this.httpService.postRequest(this.urlSearchForNeuronsIDsByCellType, {
            selectedCellTypeID: selectedCellTypeID
        }).subscribe(response => {
                this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
                this.spinner.hide();
            },
            error => {
                this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                this.spinner.hide();
            });
    }

    drawNeuronsTo3D2DScene(startIndex: number, allReceivedNeuronsIDs: [], groupName: string, groupID: number, version, colors, isNBLASTResult) {
        this.tabService.openNeuronsTab();
        // this.spinner.show();
        this.getNeuronsByIDs(startIndex, allReceivedNeuronsIDs, groupName, groupID, version, colors, isNBLASTResult);
    }

    hideProgressNeuronsLabel() {
        return this.neuronsLoadingParameters.progress != this.neuronsLoadingParameters.totalNeuronsToDraw;
    }

    cumulativeSum(array: Float32Array) {
        let sum = 0;
        return array.map(n => sum += n);
    }

    async parseChunkBinary(response) {
        let buffer;

        // If response is already an ArrayBuffer, use it directly
        if (response instanceof ArrayBuffer) {
            buffer = response;
        } else {
            // If not, handle the response as a stream and call arrayBuffer
            buffer = await response.arrayBuffer();
        }

        let dataView = new DataView(buffer);

        let offset = 0;
        let numObjects = dataView.getUint32(offset, true);
        offset += 4;
        let objects = [];
        let sizes = [];

        for (let i = 0; i < numObjects; i++) {
            let obj_id = dataView.getUint32(offset, true);
            let size = dataView.getUint32(offset + 4, true);
            offset += 8;
            objects.push({obj_id, size});
            sizes.push(size);
        }

        for (let i = 0; i < numObjects; i++) {
            let size = sizes[i];
            let x = new Float32Array(buffer, offset, size);
            let y = new Float32Array(buffer, offset + size * 4, size);
            let z = new Float32Array(buffer, offset + size * 8, size);
            let parent_ids = new Int32Array(buffer, offset + size * 12, size);
            offset += size * 16;

            // cumulative sum to undo diff
            x = this.cumulativeSum(x);
            y = this.cumulativeSum(y);
            z = this.cumulativeSum(z);

            objects[i].x = x;
            objects[i].y = y;
            objects[i].z = z;
            objects[i].parent_ids = parent_ids;
        }

        return objects;
    }

    async getNeuronsByIDs(startIndex: number, allReceivedNeuronsIDs: [], groupName: string, groupID: number, version, colors: [], isNBLASTResult) {

        this.neuronsLoadingParameters.totalNeuronsToDraw = allReceivedNeuronsIDs.length;

        let neuronsDataList = await this.neuronsService.fetchAndParseNeurons(allReceivedNeuronsIDs, version);

        await this.neuronsService.loadNeuronsIntoScenes(groupID, neuronsDataList, groupName, colors, isNBLASTResult)
    }


    async searchForNeuronsIDsByShareViewLink(neuronsGroupData, groupsNames,) {
        this.tabService.openNeuronsTab();
        console.log("========", neuronsGroupData[groupsNames[0]]);
        for (let i = 0; i < groupsNames.length; i++) {
            let groupName = groupsNames[i]

            let neuronsVersion = neuronsGroupData[groupName].visualizationOptions.neuronsVersion;

            await this.getNeuronsByIDs(0, neuronsGroupData[groupName].neuronsData.filteredNeuronsIDs, groupName, null, neuronsVersion, neuronsGroupData[groupName].neuronsData.filteredNeuronsColors, false);

        }

    }

    loadAllNeurons() {
        this.alertService.showConfirmation(
            'Are you sure you want to load all the neurons? This process may take some time and could impact the website\'s performance during future navigation.'
        ).then((confirmed) => {
            if (confirmed) {
                this.spinner.show();
                this.httpService.postRequest(this.urlLoadAllNeurons, {}).subscribe(response => {
                        this.drawNeuronsTo3D2DScene(0, response['neuronsIDs'], response['group_name'], null, 'original', [], false);
                        this.spinner.hide();
                    },
                    error => {
                        this.alertService.showErrorMsg('SOMETHING_WENT_WRONG');
                        this.spinner.hide();
                    });
            } else {
                console.log('User canceled the action.');
            }
        });
    }


}
